import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem/SliderListItem';

const BackdropDriftAmplitudeYListItem = (props) => {
    const { amplitudeY, updateBackgroundSettings } = props;

    const onAmplitudeYChange = (value) => {
        updateBackgroundSettings({ drift: { amplitudeY: value } });
    };

    return (
        <SliderListItem
            title='Y Distance'
            displayMultiplier={2}
            value={amplitudeY}
            min={0}
            max={100}
            step={1}
            onValueChange={onAmplitudeYChange}
            toolTip='Vertical movement distance.'
        />
    );
};

const mapStateToProps = (state) => {
    const { amplitudeY } = state.createPreview.present.videoSettings.background.drift;
    return { amplitudeY };
};

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings };
};

export default connect(mapStateToProps, mapDispatchToProps)(BackdropDriftAmplitudeYListItem);
